import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-spinner-base',
    template: `<div class="HOA-flex-component-center-spinner"><div class="Loader Loader--lg Loader--blue"></div></div>`,
})
export class SpinnerBaseComponent {

    constructor(@Inject(MatDialogRef<SpinnerBaseComponent>) public dialogRef: MatDialogRef<SpinnerBaseComponent>) {
        dialogRef.removePanelClass('mat-dialog-container')
    }

}
